module.exports = __webpack_public_path__ + "media/images/cplook/android-chrome-192x192-3d0a6b88131689d7b247d8504cbdc004.png";